import { useEffect, useState } from "react";
import { Form } from "antd";
import { structureFormUser } from "../../helpers/userHelpers";
import { changeDate } from "../../helpers/dayjsHelper";

const formInit = {
    name: "",
    email: "",
    password: "",
    retrypassword: "",
    rol: "",
    area: [],
    position: "",
    startedDate: "",
    fullTimeDate: "",
    isEmailList: false,
}


export const useFormUser = ({ dataForm = {}, isFormCreate = false, allAreas = [], onFinishForm = () => { } }) => {
    const [form] = Form.useForm();

    const [passwordIsNecesary, setPasswordIsNecesary] = useState(true)


    const onValuesChangeForm = (changedValues, allValues) => {
        const key = Object.keys(changedValues)[0];

        if (key === "password") {
            setPasswordIsNecesary(true)
        }
    }

    const validateRetryPassword = ({ getFieldValue }) => ({
        validator(rule, value) {
            if (!passwordIsNecesary) {
                return Promise.resolve();
            }
            if (!value || getFieldValue('password') !== value) {
                return Promise.reject('Las contraseñas no coinciden');
            }
            return Promise.resolve();
        }
    });

    const onFinish = (values) => {
        let jsonForm = values
        if (!isFormCreate) {
            const { password, ...restUser } = values;
            if (password !== "") {
                restUser.password = password;
            }
            jsonForm = restUser
        }
        const structureForm = structureFormUser(jsonForm, allAreas);
        onFinishForm(structureForm)
    }

    useEffect(() => {

        if (Object.keys(dataForm).length === 0) {
            form.setFieldsValue(formInit)
            return
        }

        form.setFieldsValue({
            ...dataForm,
            password: "",
            retrypassword: "",
            startedDate: dataForm.startedDateApi ? changeDate(dataForm.startedDateApi).day : "",
            fullTimeDate: dataForm.fullTimeDateApi ? changeDate(dataForm.fullTimeDateApi).day : "",
        })

        setPasswordIsNecesary(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataForm])


    return {
        form,
        passwordIsNecesary,
        onValuesChangeForm,
        validateRetryPassword,
        onFinish
    }
}
